<template>
  <div class="app-icons-alerts-container">
    <div class="app-icons-header-row">
      <div class="app-icons-header-col">
        <h4>App Icon & Alerts</h4>
      </div>
    </div>
    <div class="app-icons-form-row">
      <div class="app-icons-form-col">
        <div class="icon-upload-group">
          <label class="icon-label">App Logo</label>
          <div>
            <single-image
              :id="'appLogo'"
              :url="appLogo"
              @change="(val) => $emit('update-logo', val)"
              height="130px"
              width="130px"
              label="$t('Browse For App Logo')"
            />
          </div>
        </div>
        <div class="icon-upload-group">
          <label class="icon-label">Notification Logo</label>
          <div>
            <single-image
              :id="'notiIcon'"
              :url="notificationIcon"
              @change="(val) => $emit('update-notification-icon', val)"
              height="130px"
              width="130px"
              ref="notiIcon"
              label="$t('Browse For Notification Icon')"
            />
          </div>
        </div>
      </div>
      <div class="app-icons-preview-col">
        <div class="app-icons-preview-area">
          <div class="mobile-preview-wrapper">
            <mobile-view
              screen="appLogo"
              class="ml-4"
              :app-icon="appLogo"
              :app-name="appName"
            />
          </div>
          <div class="mobile-preview-wrapper">
            <mobile-view
              screen="notification"
              :notification-icon="notificationIcon"
              :app-name="appName"
            />
          </div>
        </div>
      </div>
    </div>
    <slot name="footer-button" :data="[]"></slot>
  </div>
</template>

<script>
import SingleImage from "@/components/Common/Image.vue";
import mobileView from "@/views/profile/mobileView.vue";

export default {
  name: "AppIconsAlerts",
  components: {
    SingleImage,
    mobileView,
  },
  props: {
    appLogo: { type: String, default: "" },
    notificationIcon: { type: String, default: "" },
    appName: { type: String, default: "" },
  },
  methods: {},
};
</script>

<style scoped>
.app-icons-alerts-container {
  border: 1px solid #e3eaef;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  width: 100%;
}
.app-icons-header-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 0.5rem;
}
.app-icons-header-col {
  flex: 1;
  display: flex;
  align-items: flex-end;
}
.app-icons-form-row {
  display: flex;
  gap: 32px;
  align-items: flex-start;
}
.app-icons-form-col {
  width: 25%;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e3eaef;
  padding: 24px 18px 18px 18px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 510px;
  gap: 35px;
}
.icon-upload-group {
  margin-bottom: 18px;
}
.icon-label {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
}
.icon-upload-box {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  padding: 24px 0;
  background: #fafbfc;
  text-align: center;
}
.app-icons-preview-col {
  width: 75%;
  border-radius: 8px;
  border: 1px solid #e3eaef;
  display: flex;
  max-height: 510px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}
.app-icons-preview-area {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  min-height: 260px;
  background: #f3f3f3;
  border-radius: 8px;
}
.mobile-preview-wrapper {
  max-width: 200px;
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.75);
  transform-origin: top center;
}
@media (max-width: 900px) {
  .app-icons-header-row {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }
  .app-icons-form-row {
    flex-direction: column;
    gap: 22px;
  }
  .app-icons-form-col,
  .app-icons-preview-col {
    max-width: 100%;
    width: 100%;
  }
  .app-icons-preview-area {
    flex-direction: column;
    gap: 16px;
    min-height: 180px;
  }
}
</style>
